import { ExportButton } from "@/components/export/ExportButton";
import PageHeader from "@/components/PageHeader";
import Title from "@/components/Title";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";
import MonthYearNavigation from "@/components/MonthYearNavigation";
import { usePeriodQueryParams } from "@/hooks/usePeriodQueryParams";
import { Module } from "@/constants";
import { useLimitsReportBreadcrumb } from "@/modules/limitsReport/hooks/useLimitsReportBreadcrumb";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const LimitsReport = () => {
  const { t } = useTranslation();
  const breadcrumbItems = useLimitsReportBreadcrumb();
  const [month, setMonth] = useState<Date>(new Date());
  const queryParams = usePeriodQueryParams(month);

  return (
    <div>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <Card>
        <CardHeader>
          <Title>{t("reports.navigation.limitsReport")}</Title>
          <CardDescription>
            {t("reports.limitsReport.description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-row gap-2 items-center">
            <MonthYearNavigation value={month} onMonthChange={setMonth} />
            <ExportButton
              moduleName={Module.LimitsReport}
              queryParams={queryParams}
              variant="default"
            >
              {t("reports.limitsReport.exportReport")}
            </ExportButton>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export { LimitsReport };
